import React, { useState } from 'react';
import { clustersAPI } from '../services/api';
import './DeployImageModal.css';

export default function CreateNamespaceModal({ clusterId, onClose, onCreated }) {
  const [form, setForm] = useState({ name: '', cpu_limit: '', memory_limit: '', pod_limit: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) { setError('Name is required'); return; }
    if (!/^[a-z0-9-]+$/.test(form.name)) {
      setError('Name must be lowercase letters, numbers and hyphens only');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const payload = { name: form.name };
      if (form.cpu_limit)    payload.cpu_limit    = form.cpu_limit;
      if (form.memory_limit) payload.memory_limit = form.memory_limit;
      if (form.pod_limit)    payload.pod_limit    = parseInt(form.pod_limit, 10);
      await clustersAPI.createNamespace(clusterId, payload);
      if (onCreated) onCreated(form.name);
      onClose();
    } catch (e) {
      setError(e.response?.data?.detail || e.message || 'Failed to create namespace');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="deploy-modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="deploy-modal" style={{ maxWidth: 480 }}>
        <div className="deploy-modal-header">
          <h2>📁 Create Namespace</h2>
          <button className="deploy-close" onClick={onClose}>✕</button>
        </div>

        <form onSubmit={handleSubmit} className="deploy-form">
          <div className="deploy-section">
            <div className="deploy-field">
              <label>Namespace Name *</label>
              <input value={form.name} onChange={e => set('name', e.target.value.toLowerCase())}
                placeholder="my-namespace" required />
              <div style={{ fontSize: 11, color: 'var(--muted-2)', marginTop: 4 }}>
                Lowercase letters, numbers and hyphens only
              </div>
            </div>
          </div>

          <div className="deploy-section">
            <div className="deploy-section-title">Resource Quota <span style={{ fontWeight: 400, color: 'var(--muted-2)' }}>(optional)</span></div>
            <div className="deploy-row">
              <div className="deploy-field">
                <label>CPU Limit</label>
                <input value={form.cpu_limit} onChange={e => set('cpu_limit', e.target.value)}
                  placeholder="e.g. 4 or 4000m" />
              </div>
              <div className="deploy-field">
                <label>Memory Limit</label>
                <input value={form.memory_limit} onChange={e => set('memory_limit', e.target.value)}
                  placeholder="e.g. 8Gi" />
              </div>
              <div className="deploy-field">
                <label>Max Pods</label>
                <input type="number" value={form.pod_limit} onChange={e => set('pod_limit', e.target.value)}
                  placeholder="e.g. 20" />
              </div>
            </div>
          </div>

          {error && <div className="deploy-error">{error}</div>}

          <div className="deploy-actions">
            <button type="button" className="button-secondary" onClick={onClose}>Cancel</button>
            <button type="submit" className="button-primary" disabled={loading}>
              {loading ? 'Creating...' : '📁 Create Namespace'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
